export default __webpack_public_path__ + "static/media/FG_11.34666a72.jpg";